import defaultPalette from '../palette';
export default (function (_a) {
    var _b = _a.palette, palette = _b === void 0 ? defaultPalette : _b;
    return {
        MuiIconButton: {
            root: {
                color: palette.grey[600],
                '&:hover': {
                    backgroundColor: palette.core[100] + "33",
                },
                '&$disabled': {
                    color: palette.grey[500],
                    '&$colorPrimary': {
                        color: palette.primary[100],
                    },
                    '&$colorSecondary': {
                        color: palette.secondary.light,
                    },
                },
            },
            colorPrimary: {
                color: palette.info.dark,
                '&:hover': {
                    backgroundColor: palette.action.hover + "33",
                },
            },
            colorSecondary: {
                '&:hover': {
                    backgroundColor: palette.error.light + "33",
                },
            },
            sizeSmall: {
                padding: '0.5rem',
            },
        },
    };
});
